const IconLinkedin = () => {
  return (
    <path
      d="M6.15217 9.90307H8.72391V18H6.15217V9.90307ZM7.45526 6C6.57506 6 6 6.60457 6 7.39808C6 8.17528 6.55823 8.79742 7.4216 8.79742H7.438C8.33503 8.79742 8.89366 8.17525 8.89366 7.39808C8.87683 6.60457 8.33506 6 7.45526 6ZM15.0383 9.71287C13.6731 9.71287 13.0616 10.4984 12.7204 11.0493V9.90307H10.1479C10.1819 10.6627 10.1479 18 10.1479 18H12.7204V13.4781C12.7204 13.2359 12.7372 12.9946 12.8049 12.8211C12.9912 12.3377 13.4144 11.837 14.1244 11.837C15.0559 11.837 15.4279 12.5798 15.4279 13.6678V18H18V13.357C18 10.87 16.7314 9.71287 15.0383 9.71287Z"
      fill="currentColor"
      data-testid="icon-linkedin"
    />
  );
};

export default IconLinkedin;
